import { render, staticRenderFns } from "./DashboardCMS.vue?vue&type=template&id=d2bb40e8&scoped=true"
import script from "./DashboardCMS.vue?vue&type=script&lang=js"
export * from "./DashboardCMS.vue?vue&type=script&lang=js"
import style0 from "./DashboardCMS.vue?vue&type=style&index=0&id=d2bb40e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb40e8",
  null
  
)

export default component.exports